import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { FastField, FieldProps } from 'formik';
import { UnitOfQuantityOptions as unitOfQuantities } from '../../../constants/unitOfQuantity';
import React from 'react';

interface UnitOfQuantitiesFastFieldProps {
  name: string;
  label: string;
  [x: string]: any;
}

const UnitOfQuantitiesFastField: React.FC<UnitOfQuantitiesFastFieldProps> = (props) => {
  const { name, label, disabled = false, ...other } = props;
  return (
    <FastField name={name} key={`${name}-${disabled ? 'disabled' : 'enabled'}`}>
      {({
        field, // { name, value, onChange, onBlur }
        form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta,
      }: FieldProps<any>) => {
        return (
          <FormControl fullWidth>
            <InputLabel id={name}>{label}</InputLabel>
            <Select
              labelId={name}
              disabled={disabled}
              onChange={(
                event: React.ChangeEvent<{
                  value: unknown;
                }>,
              ) => {
                form.setFieldValue(name, event.target.value as string);
              }}
              {...field}
              {...other}
            >
              {unitOfQuantities.map((unitOfQuantity) => (
                <MenuItem key={unitOfQuantity.value} value={unitOfQuantity.value}>
                  {unitOfQuantity.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      }}
    </FastField>
  );
};

export default UnitOfQuantitiesFastField;
